import { FormGroup, FormArray, AbstractControl } from "@angular/forms";

export class FormUtils {
  static markFormGroupTouched(formGroup: FormGroup | FormArray): void {
    (Object as any)
      .values(formGroup.controls)
      .forEach((control: AbstractControl) => {
        if (control instanceof FormGroup || control instanceof FormArray) {
          this.markFormGroupTouched(control);
        } else {
          control.markAsTouched();
          control.updateValueAndValidity();
        }
      });
  }

  static setupDateChangeListeners(zoneGroup: FormGroup): void {
    zoneGroup.get("startDate")?.valueChanges.subscribe((newStartDate) => {
      const endDate = zoneGroup.get("endDate");
      if (
        newStartDate &&
        endDate &&
        new Date(newStartDate) > new Date(endDate.value)
      ) {
        zoneGroup.get("endDate")?.reset("", { emitEvent: false });
        const blockedDates = zoneGroup.get("blockedDates") as FormArray;
        while (blockedDates.length > 0) {
          blockedDates.removeAt(0, { emitEvent: false });
        }
      }
    });

    zoneGroup.get("checkInTime")?.valueChanges.subscribe((newCheckInTime) => {
      const checkOutTime = zoneGroup.get("checkOutTime")?.value;
      if (newCheckInTime && checkOutTime && newCheckInTime > checkOutTime) {
        zoneGroup.get("checkOutTime")?.reset("", { emitEvent: false });
      }
    });
  }
}
